'use client'

import { Box, Button, Container, Paper, Typography } from '@mui/material'
import { useRouter } from 'next/navigation'

export default function NotFound() {
  const router = useRouter()

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          borderRadius: 2
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
          We couldn&#39;t find the page you&#39;re looking for. The page may have been moved, deleted, or never existed.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => router.back()}
            size="large"
          >
            Go back
          </Button>
          
          <Button 
            variant="outlined" 
            color="primary" 
            onClick={() => router.push('/')}
            size="large"
          >
            Go to homepage
          </Button>
        </Box>
      </Paper>
    </Container>
  )
}